// removed by extract-text-webpack-plugin
module.exports = {"search":"search__2sTuC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchInput/styles.scss
// module id = 2147
// module chunks = 1